<template>
  <div class="footer-container">
    <div class="container">
      <div class="row">
        <div class="col-xl-3 col-md-3 col-sm-12">
          <div class="logo logo-footer">
            <a href="">
              <img src="../assets/images/logo.png" alt="AptaNutricia Logo">
            </a>
          </div>
          <div class="copyright">
            <h6 class="footer-copyright text-center text-md-left">{{ new Date().getFullYear() }} © Copyright DANONE -<br /> PRODUCȚIE ȘI DISTRIBUȚIE DE<br/>PRODUSE ALIMENTARE SRL</h6>
          </div>
        </div>
        <div class="col-xl-3 col-md-3 col-sm-12 first d-flex justify-content-center">
          <div class="footer-primary-section mobile-d-none">
            <ul class="footer-menu-list">
              <a href="https://www.aptanutricia.ro/sunt-insarcinata" class="white">
                <li><span class="underline">Sunt însărcinată</span></li>
              </a>
              <a href="https://www.aptanutricia.ro/bebe-0-12-luni" class="white">
                <li><span class="underline">Bebe 0 - 12 luni</span></li>
              </a>
              <a href="https://www.aptanutricia.ro/copil-1-an" class="white">
                <li><span class="underline">Copil 1 an +</span></li>
              </a>
              <a href="https://www.aptanutricia.ro/stiinta-nutricia" class="white">
                <li><span class="underline">Știința Nutricia</span></li>
              </a>
              <a href="https://www.aptanutricia.ro/prezentare-experti" class="white">
                <li><span class="underline">Experții Nutricia </span></li>
              </a>
              <a href="https://www.aptanutricia.ro/beneficii" class="white">
                <li><span class="underline">Beneficii</span></li>
              </a>
            </ul>
          </div>
        </div>
        <div class="col-xl-3 col-md-3 col-sm-12  d-flex justify-content-center">
          <div class="footer-primary-section ">
            <ul class="footer-menu-list">
              <a href="https://www.aptanutricia.ro/politica-cookies" class="white">
                <li><span class="underline">Politica cookies</span></li>
              </a>
              <a href="https://www.aptanutricia.ro/confidentialitate" class="white">
                <li><span class="underline">Confidențialitate</span></li>
              </a>
              <a href="https://anpc.ro/" class="white">
                <li><span class="underline">ANPC</span></li>
              </a>
              <a href="https://www.aptanutricia.ro/contact" class="white">
                <li><span class="underline">Contact</span></li>
              </a>
              <a href="https://www.aptanutricia.ro/termeni-si-conditii" class="white">
                <li><span class="underline">Termeni și condiții</span></li>
              </a>
            </ul>
          </div>
        </div>
        <div class="col-xl-3 col-md-3 col-sm-12 d-flex justify-content-center">
          <div class="share-icons">
            <a href="https://www.facebook.com/Aptanutricia/" target="_blank" rel="nofollow">
              <div class="background-circle-share facebook-circle">
                <i class="fa fa-facebook-f">
                  <img src="../assets/images/fbk.png" alt="Aptanutricia Facebook">
                </i>
              </div>
            </a>
            <a href="https://www.youtube.com/channel/UC0CqVWxtsBGyvYNdfNZN3eA" target="_blank" rel="nofollow">
              <div class="background-circle-share youtube-circle">
                <i class="fa fa-youtube">
                  <img src="../assets/images/youtube.png" alt="Aptanutricia YouTube">
                </i>
              </div>
            </a>
            <a href="https://www.instagram.com/aptanutricia.ro/" target="_blank" rel="nofollow">
              <div class="background-circle-share instagram-circle">
                <i class="fa fa-instagram">
                  <img src="../assets/images/ig.png" alt="Aptanutricia Instagram">
                </i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


.footer {
  background: #c4e4f9;
  position: relative;
  z-index: 2;
}

.background-circle-share {
  background: #2c5aa9;
  border-radius: 27px;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-menu-list li {
  margin-bottom: 20px !important;
}

.footer-menu-list li span {
  font-size: 16px;
  line-height: 16px;
}

.share-icons i {
  color: #c4e4f9;
  font-size: 20px;
}

.share-icons {
  display: flex;
  justify-content: flex-end;
}
.background-circle-share i{
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-title .fa-chevron-down.fa-white {
  color: #fff;
  top: 3px;
  right: -5px;
  left: auto;
}

.share-icons a {
  margin-right: 30px;
}

.share-icons a:last-of-type {
  margin-right: 0;
}

.footer-title {
  display: flex;
}

.footer-title h6 {
  text-transform: uppercase;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  cursor: pointer;
}


.footer-primary-section, .footer-second-section {
  display: flex;
  justify-content: center;
}

.footer-primary-section ul li, .footer-second-section ul li {
  font-size: 14px;
}

.footer-title img {
  height: 16px;
  margin-left: 5px;
}

.footer-container {
  padding: 20px 0;
  background: #abcae9;
  margin-top: 60px;
}

.footer-copyright {
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: #c4e4f98c;
}

.form-subscription {
  height: 28px;
}

.form-subscription input, .form-subscription input:focus,
.form-subscription input:focus {
  background: #17479e;
  border-color: #c4e4f9;
  color: #c4e4f9 !important;
  border-radius: 30px 0 0 30px;
  font-size: 14px;
  padding: 10px 0;
  text-align: center;
  outline: none;
  box-shadow: none;
  line-height: 1.6;
  height: calc(3em + 3px);
}

.subscription-newsletter {
  padding-top: 30px;
}

.subscription-newsletter {
  display: flex;
  justify-content: center;
  alignment-baseline: central;
}

.subscription-button {
  border-radius: 0 30px 30px 0;
  background: #c4e4f9;
  padding: 9px 15px;
  font-size: 14px;
  text-align: center;
  align-items: center;
  display: flex;
  font-weight: 600;
  color: #17479e;
  height: 45px;
}

.logo.logo-footer {
  padding-top: 15px;
}
//.copyright-mobile {
//  display: none;
//}

.copyright {
  padding-bottom: 30px;
}

.footer-menu-list a:hover{
  text-decoration: none;
}

.subscription-button:hover {
  background: #a1c3da;
}

.subscription-button img {
  display: none;
}

/*Adaptive Placeholders*/
footer input[type="email"] {
  box-sizing: border-box;
  width: 100%;
  height: calc(3em + -3px);
  margin: 0 0 1em;
  padding: 6px;
  border: 1px solid #c4e4f9;
  border-radius: 3px;
  background: #17479e;
  font-size: 16px;
  resize: none;
  outline: none;
  border-radius: 30px 0 0 30px;
  padding: 10px 0;
}

footer input[type="email"]:focus {
  border-color: #c4e4f9;
}
footer input[type="email"]:focus + label[placeholder]:before {
  color: #c4e4f9;
}
footer input[type="email"]:focus + label[placeholder]:before,
footer input[type="email"]:valid + label[placeholder]:before {
  transition-duration: .2s;
  transform: translate(0, -0.7em) scale(0.9, 0.9);
  font-weight: bold;
}
footer input[type="email"]:valid {
  border-color: green;
}
footer input[type="email"]:valid + label[placeholder]:before {
  color: green;
}
footer input[type="email"]:invalid + label[placeholder][alt]:before {
  content: attr(alt);
}
footer input[type="email"] + label[placeholder] {
  display: block;
  pointer-events: none;
  line-height: 1.25em;
  margin-top: calc(-3em - 2px);
  margin-bottom: calc((3em - 1em) + 2px);
}
footer input[type="email"] + label[placeholder]:before {
  content: attr(placeholder);
  display: inline-block;
  margin: 0 calc(0.5em + 15px);
  padding: 0 2px;
  color: #c4e4f9;
  white-space: nowrap;
  transition: 0.3s ease-in-out;
  background-size: 100% 5px;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 14px;
}

.footer-menu-list li, .footer-copyright {
  color: #2c5aa9;
  margin-bottom: 10px;
  font-weight: 600;
  margin-top: 10px;
}

.footer-menu-list li{
  display: block;
}
/*End*/

@media only screen and (max-width: 992px) {

  .form-subscription {
    position: absolute;
    right: 0;
    left: auto;
    width: 85%;
  }

  .form-subscription a {
    padding: 5px 10px;
  }
}

@media only screen and (max-width: 912px) {
  .form-subscription {
    width: 90%;
  }


  .form-subscription a {
    width: 50%;
  }

  .form-subscription input {
    width: 100%;
  }
}

@media only screen and (max-width: 855px) {
  .form-subscription {
    width: 100%;
  }

  .form-subscription a {
    width: 54%;
  }
}

@media only screen and (max-width: 768px) {
  .logo.logo-footer {
    text-align: center;
  }

  .footer-primary-section, .footer-second-section, .form-subscription {
    height: auto;
    position: initial;
    top: 0;
  }

  .footer-primary-section, .footer-second-section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .footer-primary-section {
    margin-bottom: 15px;
  }

  .subscription-button img {
    display: block;
  }

  .form-subscription a {
    width: auto;
  }

  //.copyright, .mobile-d-none:first-child {
  //  display: none;
  //}

  .copyright-mobile {
    display: block;
    text-align: center;
  }

  .footer-menu-list {
    text-align: center;
  }

  .footer-primary-section {
    margin-bottom: 0;
  }

  .footer-copyright {
    font-size: 14px;
    margin-top: 25px;
  }

  .footer-copyright br {
    display: none;
  }
}

@media only screen and (max-width: 576px) {
  .subscription-newsletter {
    width: 100%;
  }
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.region-footer {
  background-color: #C4E4F9;
  position: relative;
  z-index: 10;
  margin-top: 60px;
}

.navbar-light .navbar-nav .nav-link {
  color: #17479E;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.navbar-light .navbar-nav .active > .nav-link {
  font-weight: bold;
}

.p-gray {
  color: #A0A0A0;
  font-size: 12px;
}


@media screen and (max-width: 992px) {
  .footer-nav {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  #menu-list{
    display: none !important;
  }
}
</style>
